import { useState } from 'react';
import { useRouter } from 'core/common/hooks';
import { Sidebar } from '../../Sidebar';
import { ButtonBack } from '../ButtonBack';
import { ButtonMenu } from '../ButtonMenu';
import { Logo } from '../Logo';
import { HeaderTechStyled } from './styled';

export const HeaderTech = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const router = useRouter();

  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);

  const routeBack = async () => {
    router.back();
  };

  return (
    <>
      <HeaderTechStyled>
        <ButtonBack onBack={routeBack} hasPrevPath />
        <Logo />
        <ButtonMenu onClick={toggleSidebar} />
      </HeaderTechStyled>

      <Sidebar isOpen={isSidebarOpen} onClose={toggleSidebar} />
    </>
  );
};
